import React, { useEffect, useState } from "react";
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import { styled } from '@mui/material/styles';

const CurrencyTextField = styled(TextField)({
  '& input': {
    textAlign: 'left',
  },
});


const Main = ({ default_value, value, show_message, onChange }) => {
  const [input_value, setInputValue] = useState(value?.value)
  const [has_warning, setHasWarning] = useState(false)

  useEffect(() => {
    if(default_value !== undefined) {
      doSetValue(default_value)
    }
  }, [])

  const doSetValue = (newValue) => {
    setInputValue(newValue)

    if(onChange) {
      onChange({...value, value: newValue})
    }
  }

  const hasMoreThanTwoDecimalPlaces = (input) => {
    if(input) {
      return input.split('.')[1]?.length > 2
    } else {
      return false
    }
  }

  const needsWarning = () => {
    return has_warning || hasMoreThanTwoDecimalPlaces(input_value)
  }

  return (
    <>
      <CurrencyTextField
        value={value?.value}
        type="number"
        label="Invoice Amount"
        color={needsWarning() ? 'warning' : 'primary'}
        onKeyDown={(e) => {
          if (e.key === 'e' || e.key === '-' || e.key === '+') {
            e.preventDefault()
          }
        }}
        onChange={(e) => doSetValue(e.target.value)}
        fullWidth
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <span>$</span> {/* You can replace <span>$</span> with a Dollar icon component if you have one */}
            </InputAdornment>
          ),
          inputMode: 'numeric',
        }}
      />
      {show_message && <p>{value?.message}</p>}
    </>
  )
}

export default Main;
